/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDealerDetailsHeader_viewer$ref: FragmentReference;
export type PdpSharedDealerDetailsHeader_viewer = {|
  +isNewSellerPillEnabled: ?boolean,
  +$refType: PdpSharedDealerDetailsHeader_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsHeader_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isNewSellerPillEnabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enableNewSellerPill",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"enableNewSellerPill\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7274bd88ebf0a9f442896c44aa0931c5';
module.exports = node;
